module.exports = __webpack_public_path__ + "static/media/user.9e13298d.svg";